import { useState, useEffect } from "react";

import { localStorageService } from "@services/index";

export const useIsUpdateBannerShown = () => {
  const [isUpdateBannerHidden, setIsUpdateBannerHidden] = useState<boolean>();

  useEffect(() => {
    const value = localStorageService.getUpdateBannerDate();
    setIsUpdateBannerHidden(!!value);
  }, []);

  return isUpdateBannerHidden;
};
